module.exports = __webpack_public_path__ + "static/img/20005D_1_2_R_20220712_LC.7e71373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20005D_1_2_R_20220712_LC.png
// module id = 303g
// module chunks = 0